document.querySelectorAll('.BasicHtmlContent').forEach((content) => {

    content.querySelectorAll('.slider').forEach((container) => {
        wrapElementDiv(container, 'slider__wrapper');
        tns({
            container: container,
            items: 1,
            nav: true,
            mouseDrag: true,
            controls: false,
            loop: true,
        });
    });

    content.querySelectorAll('.video__name').forEach((el) => {
        el.addEventListener('click', (e) => {
            const video = el.parentElement.querySelector('video');
            video.setAttribute('controls', '1')
            video.play();
            el.remove();
        })
    });
})
